import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 fs-6 w-275px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-item px-3" }
const _hoisted_3 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_4 = { class: "symbol symbol-50px me-5" }
const _hoisted_5 = { class: "svg-icon svg-icon-3x" }
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = { class: "fw-bolder d-flex align-items-center fs-5" }
const _hoisted_8 = { class: "menu-item px-5" }
const _hoisted_9 = { class: "menu-item px-5" }
const _hoisted_10 = { class: "menu-text" }
const _hoisted_11 = { class: "menu-item px-5 my-1" }
const _hoisted_12 = { class: "menu-item px-5 my-1" }
const _hoisted_13 = {
  key: 0,
  href: "https://valored.it/ValoreD-Inclusion_Impact_Index_Plus-Manuale_Utilizzo",
  target: "_blank",
  class: "menu-link px-5"
}
const _hoisted_14 = {
  key: 1,
  href: "https://valored.it/valored-inclusion_impact_index_plus-user_guide/",
  target: "_blank",
  class: "menu-link px-5"
}
const _hoisted_15 = {
  class: "menu-item px-5",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_16 = { class: "menu-title position-relative" }
const _hoisted_17 = { class: "fs-8 rounded bg-light px-3 py-2 position-absolute translate-middle-y top-50 end-0" }
const _hoisted_18 = { class: "menu-sub menu-sub-dropdown w-175px py-4" }
const _hoisted_19 = { class: "menu-item px-3" }
const _hoisted_20 = { class: "menu-item px-3" }
const _hoisted_21 = { class: "menu-item px-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, {
              id: "account-icon",
              src: "/media/vectorial/account.svg",
              "aria-hidden": "true"
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.userProfile.user_name), 1)
        ])
      ])
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "separator my-2" }, null, -1)),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_router_link, {
        to: `/admin/${_ctx.userProfile.id}/pages/account/overview`,
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.translate("HEADER_ACCOUNT_DATA_SUMMARY_BUTTON")), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_router_link, {
        to: `/admin/${_ctx.userProfile.id}/pages/account/company-settings`,
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.translate("HEADER_EDIT_AZIENDA_SETTINGS_BUTTON")), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_router_link, {
        to: `/admin/${_ctx.userProfile.id}/pages/account/settings`,
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.translate("HEADER_EDIT_ACCOUNT_SETTINGS_BUTTON")), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("div", _hoisted_12, [
      (_ctx.locale === 'it')
        ? (_openBlock(), _createElementBlock("a", _hoisted_13, _toDisplayString(_ctx.translate("HEADER_USER_GUIDE")), 1))
        : (_openBlock(), _createElementBlock("a", _hoisted_14, _toDisplayString(_ctx.translate("HEADER_USER_GUIDE")), 1))
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "separator my-2" }, null, -1)),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_router_link, {
        to: "#",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_16, [
            _createTextVNode(_toDisplayString(_ctx.translate("languages")) + " ", 1),
            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.currentLangugeLocale.name), 1)
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setLang('en'))),
            href: "javascript:void(0)",
            class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentLanguage('en') }])
          }, " English ", 2)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setLang('it'))),
            href: "javascript:void(0)",
            class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentLanguage('it') }])
          }, " Italiano ", 2)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("a", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSignOut && _ctx.onSignOut(...args))),
        class: "menu-link px-5"
      }, _toDisplayString(_ctx.translate("SIGN_OUT")), 1)
    ])
  ]))
}